// export const URL = "http://170.0.27.248:5000/"
// export const URL = "http://localhost/"
// export const THIS_URL = "http://localhost:3000/"
export const LOGO = ""

export const URL = "https://api.termas.com.br/"
export const THIS_URL = "https://painel.termas.com.br/"

export const API_URL = URL + 'api/';
export const STORAGE_URL = URL + 'storage/';